/**
 * Ставки НДС — раздел сметчика (миграция 0225).
 *
 * Тот же справочник, что и у экономиста: ставка одна на организацию, а
 * пользуются ею оба агента (хвост КС-2/КС-3 и сверка НДС акта — здесь, очистка
 * сумм БДР — там). Экран общий (`widgets/VatRates`), меняются только права.
 */
import { useAgentPermission } from '@entities/user';
import { VatRatesView } from '@widgets/VatRates/VatRatesView';

export function VatRates() {
  const { can_write } = useAgentPermission('smeta');
  return <VatRatesView canWrite={can_write} />;
}
